/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NotificationAppIcon20Light = forwardRef('NotificationAppIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.5 1a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7ZM12 4.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0Z" }),
        React.createElement("path", { d: "M3 5.5A2.5 2.5 0 0 1 5.5 3h4a.5.5 0 0 0 0-1h-4A3.5 3.5 0 0 0 2 5.5v8A3.5 3.5 0 0 0 5.5 17h8a3.5 3.5 0 0 0 3.5-3.5v-4a.5.5 0 0 0-1 0v4a2.5 2.5 0 0 1-2.5 2.5h-8A2.5 2.5 0 0 1 3 13.5v-8Z" })));
});
